import React, { useCallback, useEffect, useState } from "react";
import api, { formatApiError, formatTanggal } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function SaranKritikOrtu() {
  const [items, setItems] = useState([]);
  const [isi, setIsi] = useState("");
  const load = useCallback(async () => { const { data } = await api.get("/saran-kritik"); setItems(data); }, []);
  useEffect(() => { load(); }, [load]);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/saran-kritik", { isi }); toast.success("Terkirim"); setIsi(""); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Saran & Kritik" />
      <section className="pp-card p-6 mb-6">
        <form onSubmit={submit} className="space-y-4" data-testid="sk-form">
          <div><label className="pp-label">Tulis Saran / Kritik</label><textarea required rows={5} className="pp-input" value={isi} onChange={(e) => setIsi(e.target.value)} data-testid="sk-input" /></div>
          <div className="flex justify-end"><button type="submit" className="pp-btn-primary" data-testid="submit-sk"><Send className="w-4 h-4" />Kirim Saran</button></div>
        </form>
      </section>
      <h3 className="text-lg font-semibold mb-3">Riwayat Saran Anda</h3>
      <section className="space-y-3">
        {items.length === 0 && <div className="pp-card p-10 text-center italic text-slate-400">Belum ada saran/kritik.</div>}
        {items.map(s => (
          <div key={s.id} className="pp-card p-5">
            <div className="text-xs text-slate-500 mb-1">{formatTanggal(s.created_at)}</div>
            <p className="text-slate-800 whitespace-pre-wrap">{s.isi}</p>
          </div>
        ))}
      </section>
    </Layout>
  );
}
